var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown',{attrs:{"id":"account-picker","text":"Select account"}},_vm._l((_vm.userList),function(user){return _c('b-dropdown-item-button',{key:user.id,on:{"click":function($event){return _vm.setCurrentUser(user)}}},[_vm._v(" "+_vm._s(user.email_address)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }